import { render, staticRenderFns } from "./taskInfo.vue?vue&type=template&id=0293c1d4&"
import script from "./taskInfo.vue?vue&type=script&lang=js&"
export * from "./taskInfo.vue?vue&type=script&lang=js&"
import style0 from "./taskInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "taskInfo.vue"
export default component.exports